var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-provenance-explorer-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-provenance-explorer-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-provenance-explorer-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-provenance-explorer-head" }, [
                _c("div", { staticClass: "wkb-provenance-explorer-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-provenance-explorer-title" } }, [
                    _vm._v("Open provenance explorer"),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "wkb-provenance-explorer-close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "wkb-provenance-explorer-body" },
                [
                  !_vm.selectedGeneSetCount
                    ? _c("p", { staticClass: "wkb-provenance-explorer-note" }, [
                        _vm._v(
                          " Mark one or more gene sets as selected on the canvas before opening the provenance explorer. "
                        ),
                      ])
                    : [
                        _c(
                          "p",
                          { staticClass: "wkb-provenance-explorer-copy" },
                          [
                            _vm._v(
                              " Taking you to our agentic workspace. It's preloaded with the source files and analyses behind these gene sets, so you can reproduce them and trace their provenance alongside an AI agent. "
                            ),
                          ]
                        ),
                        _vm._m(0),
                        _c(
                          "p",
                          { staticClass: "wkb-provenance-explorer-helper" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedGeneSetCount) +
                                " selected gene set" +
                                _vm._s(
                                  _vm.selectedGeneSetCount === 1 ? "" : "s"
                                ) +
                                " "
                            ),
                            _vm.copyableGeneSetCount !==
                            _vm.selectedGeneSetCount
                              ? _c("span", [
                                  _vm._v(
                                    " · " +
                                      _vm._s(_vm.copyableGeneSetCount) +
                                      " with catalog ids "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm.skippedGeneSets.length
                          ? _c(
                              "ul",
                              {
                                staticClass: "wkb-provenance-explorer-skipped",
                              },
                              _vm._l(_vm.skippedGeneSets, function (entry) {
                                return _c("li", { key: entry.nodeId }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(entry.label || entry.nodeId) +
                                      ": no catalog gene set id "
                                  ),
                                ])
                              }),
                              0
                            )
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            staticClass: "wkb-provenance-explorer-copy-btn",
                            attrs: {
                              type: "button",
                              disabled: !_vm.canCopyGeneSetInformation,
                              title:
                                "Copy provenance URLs and assistant intentions for selected gene sets",
                            },
                            on: { click: _vm.onCopyGeneSetInformation },
                          },
                          [_vm._v(" Copy gene set information ")]
                        ),
                        _vm.copyFeedback
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "wkb-provenance-explorer-copy-feedback",
                                attrs: { role: "status" },
                              },
                              [_vm._v(" " + _vm._s(_vm.copyFeedback) + " ")]
                            )
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            staticClass: "wkb-provenance-explorer-open",
                            attrs: {
                              type: "button",
                              disabled: !_vm.canOpenProvenanceExplorer,
                              title: _vm.provenanceExplorerButtonTitle,
                            },
                            on: { click: _vm.onOpenProvenanceExplorer },
                          },
                          [_vm._v(" Open provenance explorer ")]
                        ),
                        !_vm.canOpenProvenanceExplorer
                          ? _c(
                              "p",
                              {
                                staticClass: "wkb-provenance-explorer-footnote",
                              },
                              [
                                _vm._v(
                                  " Provenance explorer link is not configured yet. "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-provenance-explorer-copy" }, [
      _c("strong", [_vm._v("Open provenance explorer")]),
      _vm._v(" opens that workspace in a new tab. First, use "),
      _c("strong", [_vm._v("Copy gene set information")]),
      _vm._v(
        " below, then paste it into the workspace after you are redirected—the agent needs those details to know which gene sets you are working with. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }